import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { append, patch, removeItem, updateItem } from "@ngxs/store/operators";
import { Tag, TagType } from "@vp/models";
import {
  AddSelector,
  DeleteSelector,
  PatchSelector,
  PatchState
} from "./tag-selector-state.actions";

export interface TagSelector {
  key: string;
  tagType: TagType;
  selectedTag: Tag | null;
  tags: Tag[];
  fixed: boolean;
}

export interface TagSelectorContextModel {
  selectors: TagSelector[];
}

@State<TagSelectorContextModel>({
  name: "tagSelector",
  defaults: {
    selectors: []
  }
})
@Injectable()
export class TagSelectorState {
  @Selector()
  public static getSelectors(state: TagSelectorContextModel) {
    return state.selectors;
  }

  @Selector([TagSelectorState.getSelectors])
  public static selectors(selectors: TagSelector[]) {
    return selectors;
  }

  @Action(PatchState)
  updateState(ctx: StateContext<TagSelectorContextModel>, action: PatchState) {
    ctx.patchState({ ...action.state });
  }

  @Action(PatchSelector)
  patchSelector(ctx: StateContext<TagSelectorContextModel>, action: PatchSelector) {
    ctx.setState(
      patch({
        selectors: updateItem<TagSelector>(
          ts => ts.tagType.friendlyId === action.friendlyId && ts.key === action.key,
          patch({ ...action.selector })
        )
      })
    );
  }

  @Action(AddSelector)
  addSelector(ctx: StateContext<TagSelectorContextModel>, action: AddSelector) {
    const selectors = ctx.getState().selectors;
    if (
      selectors.some(
        s =>
          s.tagType.friendlyId === action.selector.tagType.friendlyId &&
          s.key === action.selector.key
      )
    )
      return;

    ctx.setState(
      patch({
        selectors: append([{ ...action.selector }])
      })
    );
  }

  @Action(DeleteSelector)
  deleteSelector(ctx: StateContext<TagSelectorContextModel>, action: DeleteSelector) {
    ctx.setState(
      patch({
        selectors: removeItem<TagSelector>(
          ts => ts.tagType.friendlyId === action.friendlyId && ts.key === action.key
        )
      })
    );
  }
}
